import { Vue, Component } from 'vue-property-decorator';
import LayoutTable from 'components/Themes/LayoutsTable';
import Template from './template.vue';

@Component({
	components: {
		LayoutTable,
	},
})
export default class Layouts extends Vue.extend(Template) {
	protected routeLayout(id: string): void {
		this.$router.push(`/layout/${id}`);
	}

	protected openInNewTab(id: string): void {
		const route = this.$router.resolve({ name: 'EditLayout', params: { id } });
		window.open(
			route.href,
			'_blank',
		);
	}
}
